import React from 'react';
import Dashboard from './components/Dashboard';

function App() {
  return (
    <section>
      <Dashboard />
    </section>
  );
}

export default App;
